import React from 'react'
import { Link, useLocation } from "react-router-dom"
import styled from 'styled-components'

export default function Nav() {
    const location = useLocation();

    return (
        <Container>
            <StyledLink to="/" $isActive={location.pathname === "/"}>home</StyledLink>
            <StyledLink to="/bio" $isActive={location.pathname === "/bio"}>bio</StyledLink>
            <StyledLink to="/jpgs" $isActive={location.pathname === "/jpgs"}>jpgs</StyledLink>
            <StyledLink to="/mp4s" $isActive={location.pathname === "/mp4s"}>mp4s</StyledLink>
            <StyledLink to="/production" $isActive={location.pathname === "/production"}>production</StyledLink>
            <StyledLink to="/web" $isActive={location.pathname === "/web"}>web</StyledLink>
        </Container>
    )
}

const Container = styled.div`
  background: #000000;
  display: flex;
  justify-content: right;
  align-items: center;
  padding: 0.4rem 0.8rem;
  box-sizing: border-box;


  a {
    padding-left: 0.5rem;
  }

  @media screen and (max-width: 600px) {
    a {
      font-size: 0.8em;
    }
  }
`;

const StyledLink = styled(Link)`
    padding-left: .5rem;
    color: ${({ $isActive }) => ($isActive ? 'white' : 'grey')}; 
    text-decoration: none;

    &:hover {
        color: gray;
    }
`



